module.exports = __webpack_public_path__ + "img/footer-icon-row-light-mitsu.263226a8.png";